import { useI18n } from "@/hooks/useI18n";
import { Building2, Hotel, Flower2 } from "lucide-react";

export const WhoWeServe = () => {
  const { t } = useI18n();

  const segments = [
    {
      icon: Building2,
      titleKey: 'serve.wholesalers',
      description: 'Large volume orders for distribution networks',
      features: ['Bulk pricing', 'Regular supply', 'Quality consistency'],
    },
    {
      icon: Hotel,
      titleKey: 'serve.hotels',
      description: 'Premium arrangements for hospitality',
      features: ['Event flowers', 'Daily arrangements', 'Seasonal selections'],
    },
    {
      icon: Flower2,
      titleKey: 'serve.florists',
      description: 'Exclusive varieties for high-end arrangements',
      features: ['Rare varieties', 'Custom lengths', 'Express delivery'],
    },
  ];

  return (
    <section className="py-20 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-display text-2xl md:text-3xl font-light text-primary mb-6 tracking-wide">
            {t('serve.title')}
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto font-light leading-relaxed">
            Connecting Ecuador's finest flowers with premium market segments
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {segments.map(({ icon: Icon, titleKey, description, features }, index) => (
            <div
              key={titleKey}
              className="group relative overflow-hidden rounded-2xl bg-gradient-mist p-8 hover:shadow-andean transition-all duration-300 animate-fade-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Background gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-andean-mist to-transparent opacity-50 group-hover:opacity-70 transition-opacity duration-300" />
              
              <div className="relative z-10">
                <div className="w-16 h-16 bg-gradient-andean rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-8 h-8 text-andean-cream" />
                </div>

                <h3 className="font-display text-lg font-light text-primary mb-4 tracking-wide">
                  {t(titleKey)}
                </h3>

                <p className="text-muted-foreground mb-6 text-sm font-light leading-relaxed">
                  {description}
                </p>

                <ul className="space-y-2">
                  {features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-xs text-andean-sage font-light">
                      <div className="w-1.5 h-1.5 bg-accent rounded-full mr-3" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};